<template>
  <div :class="$style.container">
    <div :class="$style.container__inner">
      <div :class="$style.top">
        <!-- info -->
        <div style="overflow: hidden" :class="$style.top_right">
          <div style="float: left; width: 33%">
            <div :class="$style.phone">
              <img
                :class="$style.tel_icon"
                src="@assets/image/telephone.png"
                alt=""
              />
              <div>
                <div>全国服务热线</div>
                <div :class="$style.phone_number">
                  {{ info.customerServiceTelephone }}
                </div>
              </div>
            </div>
          </div>
          <div style="float: left; width: 33%">
            <div>{{ info.address }}</div>
            <div>客服邮箱：{{ info.email }}</div>
          </div>
          <div style="float: left; width: 33%">
            <div>
              {{ info.companyName }}
              <span
                :class="$style.recordNo"
                @click="clickLink('https://beian.miit.gov.cn')"
                >{{ info.recordNo }}
              </span>
            </div>
            <div>
              互联网域名服务许可证：<a
                style="color: #abadaf"
                href="https://domain.miit.gov.cn/域名注册服务机构/互联网域名/河北识道网络科技有限公司"
                >冀D3-20210001</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      linksList: [
        {
          title: "关于我们",
          list: [],
        },
        {
          title: "新闻中心",
          list: [],
        },
        {
          title: "招聘岗位",
          list: [],
        },
        {
          title: "解决方案",
          list: [],
        },
      ],

      info: {
        companyName: "河北识道网络科技有限公司",
        recordNo: "冀ICP备2020023246号-1",
        recordUrl: "https://beian.miit.gov.cn/",
        address: "河北省石家庄市新华区新华路351号领世商务804",
        customerServiceTelephone: "400-082-3818",
        email: "official@nsdt.com ",
        domainNameSecurityDepartment: "official@nsdt.com ",
      },
    };
  },
  methods: {
    clickLink(link) {
      link && window.open(link, "_blank");
    },
  },
};
</script>

<style lang="scss" module scoped>
.container {
  box-sizing: border-box;
  width: 100%;
  padding: rem(100) 0 rem(50);
  background: $bg-dark-1;
  color: $white;

  .container__inner {
    width: rem(1200);
    margin: 0 auto;
    color: #abadaf;
  }

  .top {
    display: flex;
    justify-content: space-between;
    font-size: rem(14);
    color: #abadaf;

    .top_left {
      flex: 1;
      display: flex;
      justify-content: space-between;

      ul {
        font-size: max(rem(16), 14px);
        color: $white;

        .title {
          padding-bottom: 20px;
        }

        li {
          list-style: none;
          font-size: rem(14);
          color: #abadaf;
          line-height: 32px;

          &.active {
            cursor: pointer;

            &:hover {
              color: #57a3f3;
            }
          }
        }
      }
    }

    .top_right {
      width: 100%;
      line-height: 32px;

      .phone {
        margin-top: rem(15);
        display: flex;
        align-items: center;
        height: rem(50);
        margin-bottom: rem(30);
        line-height: normal;

        .tel_icon {
          height: 120%;
          margin-right: rem(20);
          object-fit: cover;
        }

        .phone_number {
          margin-top: 5px;
          font-size: max(rem(24), 16px);
          white-space: nowrap;
        }
      }

      .qrcode {
        width: rem(106);
        margin-top: rem(30);
        object-fit: cover;
      }
    }
  }

  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: rem(120);
    font-size: rem(14);
    color: #abadaf;

    .recordNo {
      padding-left: 10px;
      cursor: pointer;

      &:hover {
        color: #57a3f3;
      }
    }

    .bottom_right {
      @include flex();
      gap: rem(30);
      > img {
        height: rem(50);
        object-fit: cover;
      }
    }
  }
}
</style>
